import React from 'react'

import { cn } from 'twyne-new.ui'

import { customColors } from '@/modules/cms/views/post/components/builder/Content/TailwindSandbox/Twyne/config';

import TipTapTooltip from './Tooltip';

export default function FormatterIcon({ active, onClick, icon: Icon, tooltipText, className }) {
  const activeClass = '!bg-blue-500 bg-blue-500! text-white! text-white!'
  const textClass = [customColors.twyTextBase, customColors.twyTextBaseAccentHover, customColors.twyBgBaseHover].join(' ')

  return <TipTapTooltip content={tooltipText}>
    <div className={cn(
      'flex items-center justify-center cursor-pointer p-1 rounded-xs',
      textClass,
      active && activeClass,
      className)}
      onClick={onClick}>
      <Icon size={15} />
    </div>
  </TipTapTooltip>
}
